import React from "react";
import { HOMEPAGE_ANALYSTS } from "../constants";
import {
  AnalystSection,
  AnalystHeader,
  AnalystTitle,
  AnalystLead,
  AnalystGrid,
  AnalystCard,
  AnalystCardBody,
  AvatarWrap,
  AnalystAvatar,
  AnalystName,
  AnalystRole,
  AnalystBio,
  AnalystSpecialty,
  MidCtaWrap,
  AnalystCta,
} from "./AnalystTeam.styles";

const AnalystTeam = ({ onSubscribeClick }) => (
  <AnalystSection id="analysts">
    <AnalystHeader>
      <AnalystTitle>
        Meet Your <span>Expert Team</span>
      </AnalystTitle>
      <AnalystLead>
        7 world-class analysts with combined 150+ years of trading and market
        experience
      </AnalystLead>
    </AnalystHeader>

    <AnalystGrid>
      {HOMEPAGE_ANALYSTS.map((analyst) => (
        <AnalystCard key={analyst.name}>
          <AvatarWrap>
            <AnalystAvatar
              src={analyst.profilePic}
              alt={`${analyst.name} — ${analyst.title}`}
              loading="lazy"
            />
          </AvatarWrap>
          <AnalystCardBody>
            <AnalystName>{analyst.name}</AnalystName>
            <AnalystRole>{analyst.title}</AnalystRole>
            <AnalystBio>{analyst.bio}</AnalystBio>
            <AnalystSpecialty>{analyst.specialty}</AnalystSpecialty>
          </AnalystCardBody>
        </AnalystCard>
      ))}
    </AnalystGrid>

    <MidCtaWrap>
      <AnalystCta type="button" onClick={onSubscribeClick}>
        Start Your Subscription
      </AnalystCta>
    </MidCtaWrap>
  </AnalystSection>
);

export default AnalystTeam;
